export default "__VITE_ASSET__cd887e24__"